import daysInMonth from './daysInMonth';

type Date = {
  year: string,
  month: string,
  day: string,
}

// eslint-disable-next-line import/prefer-default-export
export const validateDay = (value: Date) => {
  const { year, month, day } = value;
  if (year && month && day) {
    if (month === '02') {
      return parseInt(day) <= daysInMonth['02'](parseInt(year));
    }
    return day <= daysInMonth[month];
  }
  return false;
};
